module.exports = __webpack_public_path__ + "img/chanpin.5c56fc9c.png";